import { mergeManifests } from '@/Util/manifest';


export default {
  initPlugins({app, stores, components}) {
    var plugins=require.context("@plugins/", true, /^\.\/[^/]+\/admin\/plugin\.js$/);
    for(var plugin of plugins.keys()) {
      var pluginExport=plugins(plugin);
      if (typeof(pluginExport)=="function")
        pluginExport({app, stores, components})
    }

    var manifests=require.context("@plugins/", true, /^\.\/[^/]+\/admin\/plugin-manifest\.js$/);
    var pluginManifests=[];
    for(var key of manifests.keys())
      pluginManifests.push(manifests(key).default);
    stores.config.config=mergeManifests(
      require("@/../admin-manifest.js").default,
      ...pluginManifests,
    );

    var components=require.context("@plugins/", true, /^\.\/[^/]+\/admin\/.*\.vue$/);
    for(var key of components.keys()) {
      var plugin=key.match(/^\.\/([^/]+)/)[1];
      var component=components(key).default;
      var actualKey=(plugin?plugin+":":"")+key.replace(/\.vue|.*\//g, "");
      components[actualKey]=component;
      app.component(actualKey, component);
    }

    for(var exported of stores.config.config.exported || []) {
      var targetComponentName=exported.replace(/^[^:]+:/, "");
      app.component(targetComponentName, components[exported]);
    }

    stores.nav.items=stores.config.config.nav;
  },
}
